import Cookies from 'js-cookie';

import { AbstractStringStore, RegisteredKeyList } from './AbstractStringStore';

export class CookieStore extends AbstractStringStore {
  constructor(readonly attributes?: Cookies.CookieAttributes) {
    super('portal-cookies');
  }

  protected clearImpl(list: RegisteredKeyList): void {
    for (const { context, key } of list) {
      Cookies.remove(key, { path: context });
    }
  }

  protected removeImpl(key: string, context: string): void {
    Cookies.remove(key, { path: context });
  }

  protected retrieveImpl(key: string): string | undefined {
    return Cookies.get(key);
  }

  protected storeImpl(key: string, value: string, context: string): void {
    Cookies.set(key, value, {
      ...this.attributes,
      path: context,
    });
  }
}
